var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-list"},_vm._l((_vm.data),function(item,index){return _c('home-event-list-item',{key:index,staticClass:"item",attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }